import {
    CREATE_PROJECT,
    FETCH_PROJECT,
    VERIFY_PROJECT,
    UPDATE_DRIVERS,
    UPDATE_DRIVER_OPMODES_SELECTED,
    GENERATE_PROJECT,
    DOWNLOAD_PROJECT,
    COPY_PROJECT,
    DELETE_PROJECT,
    SET_TEMPORARY_PROJECT,
    RESET,
    RESET_PROJECT,
    FETCH_PROJECT_OPTIONS,
    UPDATE_PROJECT_OPTIONS,
    UPDATE_DRIVER_PROGRAMMING_SELECTION,
    UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION,
    FETCH_PROJECT_LOCATION,
    FETCH_PROJECT_REPORT,
    UPDATE_PROJECT_LOCATION,
    LUMINAIRE_IMAGE_PROJECT,
    FETCH_ALL_VERSIONS
} from '../actions/types';

import { getIssuesByProperty } from '../utils/validationSummary';

const INITIAL_STATE = {
    info: null,
    location: null,
    midnightShift: null,
    validationSummary: null,
    issueByProperty: {},
    downloadId: null,
    file: null,
    isTemporary: false,
    options: null,
    luminaireImage: null,
    report: null,
    versions: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_PROJECT:
            return Object.assign({}, state, {
                info: { id: action.payload },
            });
        case FETCH_PROJECT:
            return Object.assign({}, state, {
                info: action.payload,
            });
        case VERIFY_PROJECT:
        case UPDATE_DRIVERS:
        case UPDATE_DRIVER_OPMODES_SELECTED:
            return Object.assign({}, state, {
                validationSummary: action.payload,
                issueByProperty: getIssuesByProperty(action.payload),
            });
        case GENERATE_PROJECT:
            return Object.assign({}, state, {
                downloadId: action.payload,
            });
        case DOWNLOAD_PROJECT:
            return Object.assign({}, state, {
                file: action.payload,
            });

        case FETCH_PROJECT_REPORT:
            return Object.assign({}, state, {
                report: action.payload.data,
            });

        case SET_TEMPORARY_PROJECT:
            return Object.assign({}, state, {
                isTemporary: action.payload,
            });

        case COPY_PROJECT: {
            return Object.assign({}, state, {
                info: { id: action.payload },
            });
        }

        case FETCH_PROJECT_OPTIONS:
            return Object.assign({}, state, {
                options: action.payload,
            });

        case UPDATE_DRIVER_PROGRAMMING_SELECTION:
        case UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION:
            if (action.payload !== null && action.payload.validationSummary !== null) {
                return Object.assign({}, state, {
                    validationSummary: action.payload.validationSummary,
                    issueByProperty: getIssuesByProperty(action.payload.validationSummary),
                });
            }
            return state;

        case FETCH_PROJECT_LOCATION:
            if (action.payload.midnightShift === undefined) {
                action.payload.midnightShift = 90;
            }
            if (action.payload && action.payload.midnightShift !== undefined) {
                return Object.assign({}, state, {
                    location: action.payload,
                    midnightShift: action.payload.midnightShift,
                });
            } else {
                return Object.assign({}, state, {
                    location: action.payload,
                });
            }
        case UPDATE_PROJECT_LOCATION:
            return Object.assign({}, state, {
                midnightShift: action.payload,
            });

        case LUMINAIRE_IMAGE_PROJECT:
            return Object.assign({}, state, {
                luminaireImage: action.payload,
            });

        case DELETE_PROJECT:
        case RESET:
        case RESET_PROJECT:
            return INITIAL_STATE;

        case UPDATE_PROJECT_OPTIONS:

        case FETCH_ALL_VERSIONS:
            return Object.assign({}, state, {
                versions: action.payload,
            });

        default:
            return state;
    }
};
